import React from 'react';
import { Link } from 'react-router-dom';

function gameLink(props) {

	const { id, name, description } = props;
	return (<li className="list-group-item" >
		<Link to={`/play/${id}`}>
			{name} - {description}
		</Link>
	</li>
	);
}

gameLink.defaultProps = {
	name: 'unknown',
	description: 'unknown'
};

export const GameLink = React.memo(gameLink);

